/** Product tabs (Pro): tab switching, keyboard support, slider arrows, theme-editor sync. */
if (!customElements.get('product-tabs-pro')) {
  class ProductTabsPro extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.viewAll = this.querySelector('[data-view-all]');

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            const next = (i + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus();
          }
        });
      });

      this.querySelectorAll('[data-scroll]').forEach((button) => {
        button.addEventListener('click', () => {
          const track = this.querySelector('[role="tabpanel"]:not([hidden]) [data-track]');
          if (!track) return;
          const card = track.firstElementChild;
          const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
          track.scrollBy({ left: step * (button.dataset.scroll === 'next' ? 1 : -1), behavior: 'smooth' });
        });
      });

      this.addEventListener('shopify:block:select', (event) => {
        const i = this.tabs.findIndex((tab) => tab.dataset.blockId && event.target.contains?.(tab));
        const byId = this.tabs.findIndex((tab) => tab.id === `${event.target.id}`);
        const index = i >= 0 ? i : byId;
        if (index >= 0) this.select(index);
      });
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });
      const url = this.tabs[index]?.dataset.url;
      if (this.viewAll && url) this.viewAll.href = url;
    }
  }

  customElements.define('product-tabs-pro', ProductTabsPro);
}
